import { Route } from "found";

import CatalixStartSessionErrorPage from "pstat-anywhere/components/integrations/catalix/StartSessionErrorPage";

const routes = (
  <Route
    path="/start_session"
    data={{
      routeName: "catalix_start_session_error"
    }}
    Component={CatalixStartSessionErrorPage}
  />
);

export default routes;
